import React from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import { capitalizeFirstLetter } from 'UI/utils';

const SKELETON_PROPS = {
  'aria-label': 'loading-skeleton',
  height: 16
};

/**
 * @param {Object} props
 * @param {boolean} props.isLoading
 * @param {(IndustryType|SpecialtyType|SubspecialtyType|null)} props.pilResults
 * @param {('industry'|'specialty'|'subspecialty'|null)} props.type
 */
const PilBreadcrumb = ({ isLoading, pilResults, type }) => {
  const {
    industry_title: industry = '',
    specialty_title: specialty = '',
    title = ''
  } = pilResults ?? {};

  const pilBreadcrumb = {
    industry: {
      industry: capitalizeFirstLetter(type ?? ''),
      specialty: null,
      subspecialty: null
    },
    specialty: {
      industry,
      specialty: title,
      subspecialty: null
    },
    subspecialty: {
      industry,
      specialty,
      subspecialty: title
    }
  };

  return (
    <div aria-label="pil breadcrumb">
      {type && (
        <>
          {isLoading ? (
            <Skeleton {...SKELETON_PROPS} width={250} />
          ) : (
            <Breadcrumbs aria-label="breadcrumb">
              <Typography color="textPrimary">{pilBreadcrumb[type].industry}</Typography>

              {pilBreadcrumb[type].specialty && (
                <Typography color="textPrimary">{pilBreadcrumb[type].specialty}</Typography>
              )}

              {pilBreadcrumb[type].subspecialty && (
                <Typography color="textPrimary">{pilBreadcrumb[type].subspecialty}</Typography>
              )}
            </Breadcrumbs>
          )}
        </>
      )}
    </div>
  );
};

export default PilBreadcrumb;
